import api from './api';
import type {
  CrmActividad,
  CrmActividadCreate,
} from '../types/crm';

export interface CrmActividadSearch {
  contactoId?: number;
  oportunidadId?: number;
}

const crmActividadService = {
  getAll: async (params: CrmActividadSearch = {}): Promise<CrmActividad[]> => {
    const response = await api.get<CrmActividad[]>('/api/CrmActividades', { params });
    return response.data;
  },

  create: async (dto: CrmActividadCreate): Promise<CrmActividad> => {
    const response = await api.post<CrmActividad>('/api/CrmActividades', dto);
    return response.data;
  },
};

export default crmActividadService;
